import { StoreSchema } from '../../types/store'

export const selectRightBar = (store: StoreSchema) => store.rightBar
export const selectRightBarHiddenState = (store: StoreSchema) => store.rightBar.rightBarHidden
export const selectRightBarFullScreen = (store: StoreSchema) => store.rightBar.fullScreen
// NOTE: not used in any component yet. Do not delete
export const selectRightBarHalfScreen = (store: StoreSchema) => store.rightBar.halfScreen
export const selectActionBarState = (store: StoreSchema) => store.rightBar.actionsBar
export const selectScheduleBarState = (store: StoreSchema) => store.rightBar.scheduleBar
export const selectRightBarItem = (store: StoreSchema) => store.rightBar.rightBarItem